import React from 'react';
import SEO from '../components/SEO';
import { useParams, Link } from 'react-router-dom';
import { blogPosts } from '../data/blogData';

const BlogSingle = () => {
  const { slug } = useParams();
  const post = blogPosts.find(post => post.slug === slug);

  if (!post) {
    return <div className="container mt-5 pt-5"><h2>Blog post not found</h2></div>;
  }

  return (
    <>
      <SEO 
        title={`${post.title} | Franklin's Blog`}
        description={post.excerpt}
        image={post.image}
        type="article"
      />
    <main>
      <section className="blog-single pb-0">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="portfolio-meta d-flex align-items-center">
                <div className="portfolio-terms">
                  {post.tags.map((tag, index) => (
                    <Link key={index} className="terms" to="/blog">{tag}</Link>
                  ))}
                </div>
                <span className="date">{post.readTime} read</span>
              </div>
              <h2 className="title">{post.title}</h2>
              <div className="content item d-flex flex-column flex-md-row">
                <div className="author d-flex align-items-start">
                  <div className="blog-article-logo">f</div>
                  <div className="content ms-3">
                    <h6 className="title mt-0 mb-2">Author</h6>
                    <span><strong>{post.author}</strong></span>
                  </div>
                </div>
                <div className="published ms-sm-4 my-3 my-sm-0">
                  <h6 className="title mt-0 mb-2">Published</h6>
                  <span>{post.date}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center portfolio-content">
            <div className="col-12 blog">
              <div className="post-thumbnail mb-4">
                <img loading="lazy" className="w-100" alt={post.title} src={post.image} />
              </div>
              <div dangerouslySetInnerHTML={{ __html: post.content }} />
              <div className="post-holder-tags d-flex flex-column flex-md-row align-items-md-center my-5">
                <span className="tagged">Tagged with:</span>
                <div className="tags mt-2 mt-sm-0 ms-sm-3">
                  {post.tags.map((tag, index) => (
                    <span key={index} className="badge text-bg-light" rel="tag">{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    </>
  );
}

export default BlogSingle;